import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-loop",
  "use": "icon-loop-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-loop\"><path d=\"M8.312 2.168a6.15 6.15 0 0 1 6.143 6.143 6.15 6.15 0 0 1-6.143 6.144A6.15 6.15 0 0 1 2.169 8.31a6.15 6.15 0 0 1 6.143-6.143zm11.26 16.582l-4.899-5.095a8.285 8.285 0 0 0 1.95-5.344C16.623 3.73 12.895 0 8.312 0S0 3.729 0 8.311c0 4.583 3.729 8.312 8.312 8.312 1.72 0 3.36-.52 4.762-1.504l4.936 5.134c.206.214.484.333.781.333a1.085 1.085 0 0 0 .781-1.835z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol